<script setup>
import { useI18n } from 'vue-i18n'
import { PageHeader } from '@drama/ui'

import { scenarioId } from './scenario.js'
import RecallTestTab from './RecallTestTab.vue'
import ScenarioSelect from './ScenarioSelect.vue'

const { t } = useI18n()
</script>

<template>
  <div class="intent-videos-page vga-page" data-insp-path="apps/visual-game-admin/src/pages/intent-video/RecallPage.vue">
    <PageHeader :title="t('visualGameAdmin.intentVideo.tabs.recall')">
      <template #subtitle>
        <span>{{ t('visualGameAdmin.intentVideo.subtitle') }}</span>
      </template>
      <template #actions>
        <ScenarioSelect />
      </template>
    </PageHeader>

    <RecallTestTab v-if="scenarioId !== ''" :key="scenarioId" :scenario-id="scenarioId" />
  </div>
</template>
